import React, { useState } from 'react'
import Button from './Button';
import styled from "styled-components";

const FormStyle = styled.div `
  .form {
    height: 530px;
    left: 5rem;
    bottom: 8%;
  }

  .title {
      padding-top: 25px;
    }

  .message {
    height: 175px;
      width: 100%;
      rows: 4
  }

  @media (max-width: 615px) {
    .form {
      height: 445px;
      width: 330px;
      bottom: 350px;
      left: 50%;
      right: 50%;
      transform: translate(-50%);
    }

    .title {
      padding-top: 4px;
    }
    .message {
      height: 95px;
      width: 100%;
      rows: 4
    }
  }
`

function ContactForm({ sendForm }) {
 
  const [ form, setForm ] = useState({
    senderEmail: '',
    senderName: '',
    senderMessage: '',
  })

  const [formSuccess, setFormSuccess] = useState(false);

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });

  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const handleSubmit = () => {
    if (!form.senderName) return setFormError({
      field: 'name',
      msg:  "Please add your name." 
    });
    if (!validateEmail(form.senderEmail)) return setFormError({
      field: 'email',
      msg:  "Please add a valid email." 
    });
    if (!form.senderMessage) return setFormError({
      field: 'message',
      msg:  "Please enter a message." 
    });
    setFormError({
      field: '',
      msg: ''
    })
    sendForm(form);
    setFormSuccess(true);
    setForm({
      senderEmail: '',
      senderName: '',
      senderMessage: '',
    });
    setTimeout(() => {
      setFormSuccess(false);
    }, 5000);
  }

  return (
    <FormStyle>
      <div className="form px-6 bg-white w-96 shadow-lg rounded-md absolute z-10">
        <div className="text-center">
          <h1 className="title my-2 text-lg font-semibold text-lpGray">Need more help?</h1>
          <p className="my-2 text-base">We'de be happy to assist you every step of the way, whether it's discussing your concerns or learning more about partner benefits.</p>
        </div>
        <div className="flex flex-col pb-6">
          <input type="text" label="name" placeholder="Name" value={form.senderName} onChange={(e) => setForm((form) => ({ ...form, senderName: e.target.value }))} className="placeholder-lpGray text-sm lg:text-base px-4 mt-2 h-10 bg-bgGray rounded"></input>
          {formError.field === 'name' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <input type="email" label="email" value={form.senderEmail} placeholder="Email" onChange={(e) => setForm((form) => ({ ...form, senderEmail: e.target.value }))} className="placeholder-lpGray text-sm lg:text-base px-4 mt-2 h-10 bg-bgGray rounded"></input>
          {formError.field === 'email' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <textarea label="message" placeholder="Message" rows="4" value={form.senderMessage} onChange={(e) => setForm((form) => ({ ...form, senderMessage: e.target.value }))} className="message placeholder-lpGray resize-none text-sm lg:text-base px-4 py-2 mt-2 bg-bgGray rounded"></textarea>
          {formError.field === 'message' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          {formSuccess && 
          <span className="text-green-600 text-sm col-span-4">Message sent successfully!</span>
          }
          <Button text="SEND NOW" onClick={handleSubmit} className="w-full mt-2"/>
        </div>
      </div>
    </FormStyle>
  )
}

export default ContactForm;